import state from './state'
export default {
  state,
  mutations: {
      setListScrollTop(state, top) {
        state.listPageScrollTop = top
      },
      setCareerTalkPosition(state, position) {
        state.careerTalkPosition = position
      },
      setSeesionDetail(state, seesionDetail) {
        state.seesionDetail = seesionDetail
      }
  },
  actions: {},
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/positionList/index.js